import { defineCustomElements } from '@progleasing/grit-universal/loader';

export function gritUniversalInitialize() {
  return () => {
    const win = window as any;
    if (typeof win !== 'undefined') {
      // Define all of our custom elements
      defineCustomElements(win);
    }
  };
}
